import React from 'react';
import './ContactUsHeroArea.css';

const ContactUsHeroArea = () => {
    return (
        <section className="contactUs-hero-section">
            <div className="contactUs-bgOverlay">
                <div className="container">
                    <div className="contactUs-content">
                        <h4>Home / Contact Us</h4>
                        <h1>Contact Us</h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactUsHeroArea;